export default "__VITE_ASSET__b969a4fc__"